const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  cachedViews: state => state.tagsView.cachedViews,
  roles: state => state.user.roles,
  userinfo: state => state.user.userinfo,
  permission_routes: state => state.permission.routes
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js